import * as actionTypes from './actionTypes';
import axios from '../../utilities/interceptor';
import { getMessage } from '../../utilities/getMessage';

export const getAgentTransactionDetail=(id,date)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_AGENT_TRANSACTION_DETAIL_START
    })
    await axios.get(`transactions/agent/${id}/${date}`)
                .then(response=>dispatch({
                    type:actionTypes.GET_AGENT_TRANSACTION_DETAIL_SUCCESS,
                    payload:response.data
                }))
                .catch(error=>dispatch({
                    type:actionTypes.GET_AGENT_TRANSACTION_DETAIL_FAIL,
                    payload:getMessage(error)
                }))
}